import { render } from "./ChatBotSmoochPM.vue.ts?vue&type=template&id=ca2f90eb&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochPM.vue?vue&type=template&id=ca2f90eb&ts=true"
import script from "./ChatBotSmoochPM.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochPM.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatBotSmoochPM.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochPM.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/person-registration/components/chat-bot/ChatBotSmoochPM.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca2f90eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca2f90eb', __exports__)) {
    api.reload('ca2f90eb', __exports__)
  }
  
  module.hot.accept("./ChatBotSmoochPM.vue.ts?vue&type=template&id=ca2f90eb&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotSmoochPM.vue?vue&type=template&id=ca2f90eb&ts=true", () => {
    api.rerender('ca2f90eb', render)
  })

}


export default __exports__